import { ReactNode } from "react";
import { useCerberus } from "../../hooks/useCerberus";
import { Role } from "./Role";

const DisplayForRoles = ({
  children,
  roles,
}: {
  children: ReactNode;
  roles: Role[];
}) => {
  const { roles: userRoles } = useCerberus();

  let hasAccess = false;

  if (userRoles) {
    roles.forEach(function (requiredRole) {
      if (userRoles.includes(requiredRole)) hasAccess = true;
    });
  }

  if (!hasAccess) {
    return <></>;
  }

  return children;
};

export default DisplayForRoles;
